import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { MsalBroadcastService, MsalService } from "@azure/msal-angular";
import { SessionStorageService } from "@core/services/session-storage.service";
import { Observable, catchError, filter, map, of, switchMap, take } from "rxjs";
import { AuthenticationWrapperService } from "@core/services/service-wrappers/authentication-wrapper.service";
import { InteractionStatus } from "@azure/msal-browser";

@Injectable({
    providedIn: 'root'
})
export class SecurityService {
    claims: any;
    GET_AUTH_CLIENTS = '/api/v1/authentication/authorized-clients';

    constructor(private authService: MsalService, private router: Router,
        private sessionStorageService: SessionStorageService, private authenticationWrapperService: AuthenticationWrapperService,
        private msalBroadcastService: MsalBroadcastService) {
    }

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean | UrlTree> {
        return this.authService.initialize().pipe(
            switchMap(() => this.msalBroadcastService.inProgress$.pipe(
                filter((status: InteractionStatus) => status === InteractionStatus.None),
                take(1),
                switchMap(() => {
                    let account = this.authService.instance.getActiveAccount();
                    if (!account && this.authService.instance.getAllAccounts().length > 0) {
                        account = this.authService.instance.getAllAccounts()[0];
                        this.authService.instance.setActiveAccount(account);
                    }

                    this.claims = account?.idTokenClaims as Record<string, any>;
                    const authId = account?.localAccountId;
                    const cl = this.sessionStorageService.getItem('custom-logo') ?? '';

                    if (authId != null && authId !== '') {
                        return this.authenticationWrapperService.apiV1AuthenticationAuthorizedClientsIdGet(authId)
                            .pipe(map(a => {
                                let clientId = this.sessionStorageService.getItem('peregrine-client-id');
                                if (a.authorizedClients !== null && a.authorizedClients.findIndex(c => c === 'imagine-admin-user') >= 0) return true;
                                if (a.authorizedClients !== null && cl !== '' && cl === 'opus_logo.png' && a.authorizedClients.findIndex(c => c === 'opus-admin-user') >= 0) return true;
                                if (clientId == null || a.authorizedClients.findIndex(c => c === clientId) >= 0) return true;
                                return this.router.parseUrl('/unauthorized')
                            }),
                                catchError(err => { return of(this.router.parseUrl('/unauthorized')) }))

                    }

                    return of(this.router.parseUrl('/unauthorized'));
                })
            )),
            catchError(err => { return of(this.router.parseUrl('/unauthorized')) })
        );
    }
}
